// helper.js
import { useState, useEffect } from "react";
import { Connection, PublicKey } from "@solana/web3.js";
import {
  TOKEN_PROGRAM_ID,
  getAssociatedTokenAddress,
  getAccount
} from "@solana/spl-token";

/**
 * @param {Object} props
 * @param {string} props.tokenMintAddress - 要监听的Token合约（Mint）地址
 * @param {string} props.walletAddress    - 用户钱包地址
 *
 * @return {number | null}               - 返回监听到的Token余额(最小单位), 如果还未获取到则返回 null
 */
export function TokenBalanceSocket({ tokenMintAddress = 'AY2Qidgrky4TFymeJKe36w5buY7QWK7TSd7obQLupump', walletAddress}) {
  const [balance, setBalance] = useState(null);
  // const  rpcUrl="https://rpc.ankr.com/solana/80465c767c6a5751c4cadf0778b6917d26c2d0a9ae583d3616ffaae71191a7c4"
  const rpcUrl = "https://mainnet.helius-rpc.com/?api-key=87eb0292-8ed2-4c97-94a3-2a325517875b"

  useEffect(() => {
    if (!tokenMintAddress || !walletAddress || !rpcUrl) {
      return ;
    }
    let subscriptionId;
    // 建立Connection需要指定 commitment，"confirmed" 或 "finalized" 都可
    const connection = new Connection(rpcUrl, "confirmed");
    const setupSubscription = async () => {
      try {
        // 1) 计算 Associated Token Account
        const tokenAccount = await getAssociatedTokenAddress(
          new PublicKey(tokenMintAddress),
          new PublicKey(walletAddress),
          false,               // allowOwnerOffCurve = false
          TOKEN_PROGRAM_ID
        );
        // 2) 获取初始余额
        //    直接用 getAccount() 来解析 SPL Token账户数据，拿到 amount（BigInt）
        try {
          const tokenAcc = await getAccount(connection, tokenAccount);
          setBalance(Number(tokenAcc.amount)); // tokenAcc.amount 是 BigInt
        } catch (err) {
          // 若 user 没有这个 tokenAccount，getAccount() 可能报错；可忽略或设置余额为0
          console.warn("No token account found, or error parsing initial balance:", err);
          setBalance(0);
        }

        // 3) 设置 WebSocket 监听
        subscriptionId = connection.onAccountChange(
          tokenAccount,
          async () => {
            // 当 Token账户 发生变化时，重新获取账户数据
            try {
              const tokenAcc = await getAccount(connection, tokenAccount);
              setBalance(Number(tokenAcc.amount));
            } catch (error) {
              console.error("Error updating token balance:", error);
              // 如果用户把Token账户清理或销毁，也可能会报错；可视情况赋值 0
              setBalance(0);
            }
          },
          "confirmed"
        );
      } catch (error) {
        console.error("Error setting up token balance subscription:", error);
      }
    };

    setupSubscription();

    // 4) Cleanup 函数：组件卸载时，移除监听
    return () => {
      if (subscriptionId) {

        connection.removeAccountChangeListener(subscriptionId).catch((err) => {
          console.error("Error removing account change listener:", err);
        });
      }
    };
  }, [tokenMintAddress, walletAddress, rpcUrl]);

  return balance;
}